<template>
    <div>
        <!-- <h1>{{ $t('betalingfejl')}}</h1> -->
        <h1>{{ $t('vaerelserogantal') }}</h1>
        <!-- <p>afterAddonData: {{ this.$store.getters.afterAddonData.booking.rooms }}</p> -->
        <!-- <p>Hotel: {{ this.hotel }}</p> -->

        <detailedExtras v-on:totalNoChecked="totalNoCheckedFromChild" :postnr="hotel" roomtype="vaerelse" cart="addToAfterAddonCart" :startdate="this.$store.getters.afterAddonData.booking.arrival" :enddate="this.$store.getters.afterAddonData.booking.departure" :rooms="this.$store.getters.afterAddonData.booking.rooms" :wants="wants"></detailedExtras>

        <div class="buttonContainer">
            <router-link :to="{name: 'efterbestilling'}">
                <div class="continueButton">
                    <a>&laquo; {{ $t('tilbage')}}</a>
                </div>
            </router-link>

            <router-link v-if="this.totalNoChecked === 0" :to="{name: 'efterbestilling2'}">
                <div class="continueButton" style="opacity: 0.2;">
                    <a>{{ $t('tilbekraeftelse') }} &raquo;</a>
                </div>
            </router-link>

            <router-link v-else :to="{name: 'efterbestilling3'}">
                <div class="continueButton">
                    <a>{{ $t('tilbekraeftelse') }} &raquo;</a>
                </div>
            </router-link>
        </div>

    </div>
</template>

<script>
import i18n from '@/plugins/i18n';
import detailedExtras from "@/components/detailedExtras.vue";

export default {
    components: {
        detailedExtras
    },
    data() {
        return {
            locale: i18n.locale,
            apiLoaded: 0,
            login: {'invoiceno': '', 'doorcode': ''},
            loginError: {'invoiceno': '', 'doorcode': ''},
            hotel: this.$store.getters.afterAddonData.hotel,
            totalNoChecked: 0
        };
    },
    computed: {
        wants() {
            return this.$store.getters.afterAddonData.booking.rooms.map(wants => wants.id_room)
        }
    },
    created() {
        console.log('Hotel: '+this.$store.getters.afterAddonData.hotel)
    },
    methods: {
        // Tag totalNoChecked fra detailedEkstras komponent, og lig i lokal variabel så den kan ses i template sektionen
        totalNoCheckedFromChild(no) {
            this.totalNoChecked = no;
        }
    }
}
</script>

<style scoped>

.flex-container {
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction:row;
  -ms-flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.flex-item {
  padding: 10px;
  width: 85vw;
  max-width: 330px;
  height: 150px;
  margin-top: 10px;
  display: flex;
}

/* Giver de enkelte input-elementer styling, hvid border, transparent baggrund og padding */
.form input[type="text"], [type="checkbox"], textarea {
    background: transparent;
    border: 2px solid white;
    color: white;
    padding: 5px;
}

.form ::placeholder {
    color: rgba(255, 255, 255, 0.50);
}

/* Flex container, angiver hvordan den skal opføre sig ved smallere viewport */
.form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;
    max-width: 1024px;
    margin: 0 auto;
    
}
/* De enkelte kolonner i flexboxen */
.formColumn {
    flex: 0 0 30%;
    padding: 5px;
}

::placeholder {
    color: white;
    opacity: 1;
}

.error {
    color: red;
    font-weight: bold;
}

/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 50px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;
}

.buttonContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 50px;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 280px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 20px;
  white-space: nowrap;
  cursor: pointer;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
  line-height: 80px;
}
</style>